<template>
  <div class="blinkist-logo">
    <!-- eslint-disable -->
    <svg
      v-if="type === 'no-text'"
      :class="{ 'w-7 h-7': useDefaultSize, [logoClasses]: logoClasses }"
      height="34"
      viewBox="0 0 36 34"
      width="36"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m25.2051102.0058957-7.6622492 7.79322777-7.66224914-7.79322777c-5.84848983 2.89331356-9.88061186 8.99241264-9.88061186 16.0516261 0 9.8543636 7.85411695 17.842739 17.542861 17.842739 9.6884543 0 17.5425712-7.9883754 17.5425712-17.842739 0-7.05921346-4.032122-13.15831254-9.880322-16.0516261"
        fill="#2cde80"
      />
      <path
        d="m22.1946407 12.5304207-4.6517797-4.73129723-4.6520695 4.73129723c-2.5690576 2.6129732-2.5690576 6.8496214 0 9.4628893 2.5693475 2.6129732 6.7347916 2.6129732 9.3038492-.0002947 2.5690576-2.6129732 2.5690576-6.8493266 0-9.4625946"
        fill="#002f54"
      />
    </svg>

    <svg
      v-if="type === 'no-text-2'"
      width="39"
      height="37"
      viewBox="0 0 39 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_1155_18936"
        style="mask-type: alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="39"
        height="37"
      >
        <path fill-rule="evenodd" clip-rule="evenodd" d="M19.5 0L0 0V37H39V0H19.5V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_1155_18936)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M28.0117 0L19.4903 8.51174L10.9689 0C4.46469 3.16007 -0.0195312 9.82148 -0.0195312 17.5315C-0.0195312 28.2944 8.71522 37.0193 19.4903 37.0193C30.2651 37.0193 38.9998 28.2944 38.9998 17.5315C38.9998 9.82148 34.5156 3.16007 28.0117 0"
          fill="#2CE080"
        />
      </g>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M24.6637 13.6792V13.6792L19.4903 8.51172L14.3167 13.6792C11.4596 16.5331 11.4596 21.1604 14.3167 24.0146C17.1741 26.8684 21.8066 26.8684 24.6637 24.0142C27.5208 21.1604 27.5208 16.5334 24.6637 13.6792"
        fill="#03314B"
      />
    </svg>

    <svg
      v-if="type === 'full'"
      :class="{ 'blinkist-logo--full': useDefaultSize, [logoClasses]: logoClasses }"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 134 26"
      enable-background="new 0 0 134 26"
    >
      <path
        fill="#2CE080"
        d="M19.8,0l-6,6l-6-6C3.1,2.2,0,6.9,0,12.3C0,19.9,6.1,26,13.7,26 c7.6,0,13.8-6.1,13.8-13.7C27.5,6.9,24.3,2.2,19.8,0z"
      />
      <path
        fill="#03314B"
        d="M17.4,9.6L13.7,6l-3.6,3.6c-2,2-2,5.3,0,7.3c2,2,5.3,2,7.3,0 C19.4,14.9,19.4,11.6,17.4,9.6z"
      />
      <path
        fill="#002F54"
        d="M44.1,16.7c0-1.1-0.8-1.7-1.9-1.7h-3.8v3.3h3.8 C43.4,18.3,44.1,17.8,44.1,16.7z M38.4,7.7V11h1.8c1.2,0,1.9-0.7,1.9-1.7c0-1-0.7-1.7-1.9-1.7H38.4z M49,16.9c0,3.3-2.8,5.7-6.5,5.7 h-8.9v-19h6.9c3.7,0,6.5,2.2,6.5,5.6c0,1.3-0.4,2.4-1.2,3.2C47.8,13.1,49,14.6,49,16.9z"
      />
      <path fill="#03314B" d="M51.4,22.5h5V0.9h-5V22.5z" />
      <path
        fill="#002F54"
        d="M59.6,22.5h5V8.1h-5V22.5z M65.2,3c0,1.6-1.4,2.9-3.1,2.9 c-1.7,0-3-1.3-3-2.9c0-1.7,1.4-2.9,3-2.9C63.8,0.1,65.2,1.3,65.2,3z"
      />
      <path
        fill="#03314B"
        d="M82,13.6v8.9h-5v-8.2c0-1.3-0.9-2.1-2.1-2.1 c-1.2,0-2.1,0.8-2.1,2.1v8.2h-5V8.1h4.5v1.2c1-0.9,2.4-1.5,4.1-1.5C79.9,7.8,82,10.1,82,13.6z"
      />
      <path fill="#03314B" d="M95.3,22.5l-5.2-7.6v7.6h-5V0.9h5v13l4.5-5.8h5.8l-5,6.4l5.3,8 H95.3z" />
      <path
        fill="#002F54"
        d="M102.4,22.5h5V8.1h-5V22.5z M107.9,3c0,1.6-1.4,2.9-3.1,2.9 c-1.7,0-3-1.3-3-2.9c0-1.7,1.4-2.9,3-2.9C106.5,0.1,107.9,1.3,107.9,3z"
      />
      <path
        fill="#03314B"
        d="M121.3,9.9l-2.3,3c-1-0.8-2-1.2-3.1-1.2c-0.6,0-1,0.1-1,0.5 c0,0.4,0.3,0.5,1,0.8l1.4,0.6c2.6,1,4.2,2.1,4.2,4.5c0,3-2.5,4.8-6,4.8c-2.6,0-4.9-1-6.2-2.8l2.3-2.9c1.2,1.2,2.6,1.8,4,1.8 c0.7,0,1.3-0.1,1.3-0.6c0-0.3-0.3-0.5-0.8-0.7l-1.6-0.7c-2.6-1.1-4.2-2.2-4.2-4.6c0-2.9,2.3-4.6,5.6-4.6 C118,7.7,119.9,8.4,121.3,9.9z"
      />
      <path
        fill="#03314B"
        d="M134,18.4v4.2c-0.8,0.2-1.8,0.3-2.9,0.3c-4,0-6.4-1.9-6.4-5.9v-4.8 h-2.2V8.1h2.2V4.6h5v3.5h3.9v4.2h-3.9v4.3c0,1.4,0.7,1.9,2.5,1.9C132.6,18.4,133.2,18.4,134,18.4z"
      />
    </svg>

    <svg
      v-if="type === 'business'"
      :class="{ 'blinkist-logo--business': useDefaultSize, [logoClasses]: logoClasses }"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 249 27"
    >
      <path
        d="M19.77 0L13.77 6L7.76997 0C5.5748 1.07727 3.70769 2.72204 2.36217 4.76383C1.01666 6.80561 0.241702 9.1701 0.117636 11.6122C-0.00642889 14.0543 0.52491 16.4852 1.65658 18.6528C2.78825 20.8204 4.47906 22.646 6.55375 23.9402C8.62845 25.2344 11.0115 25.9501 13.456 26.0132C15.9004 26.0764 18.3173 25.4846 20.456 24.2992C22.5948 23.1139 24.3776 21.3781 25.6196 19.2718C26.8617 17.1654 27.5178 14.7653 27.52 12.32C27.5185 9.74524 26.7904 7.22317 25.4194 5.04377C24.0484 2.86436 22.0903 1.1161 19.77 0V0Z"
        fill="#2CDE80"
      />
      <path
        d="M17.41 9.61L13.76 6L10.11 9.61C9.39213 10.3312 8.904 11.2489 8.70721 12.2472C8.51042 13.2456 8.6138 14.2798 9.00429 15.2195C9.39478 16.1591 10.0549 16.9621 10.9013 17.5269C11.7477 18.0917 12.7424 18.3932 13.76 18.3932C14.7775 18.3932 15.7723 18.0917 16.6187 17.5269C17.4651 16.9621 18.1252 16.1591 18.5157 15.2195C18.9062 14.2798 19.0096 13.2456 18.8128 12.2472C18.616 11.2489 18.1278 10.3312 17.41 9.61Z"
        fill="#002F54"
      />
      <path
        d="M45.83 12.31C46.6057 11.4267 47.023 10.2853 47 9.10999C47 5.73999 44.19 3.48999 40.54 3.48999H33.64V22.49H42.57C46.25 22.49 49.03 20.18 49.03 16.84C49.046 15.8431 48.7447 14.867 48.1694 14.0527C47.5942 13.2383 46.7749 12.6281 45.83 12.31ZM38.41 7.66999H40.21C40.4488 7.63796 40.6916 7.65736 40.9223 7.72687C41.153 7.79638 41.3661 7.9144 41.5474 8.07303C41.7287 8.23165 41.8741 8.4272 41.9736 8.64658C42.0732 8.86595 42.1247 9.10408 42.1247 9.34499C42.1247 9.5859 42.0732 9.82403 41.9736 10.0434C41.8741 10.2628 41.7287 10.4583 41.5474 10.617C41.3661 10.7756 41.153 10.8936 40.9223 10.9631C40.6916 11.0326 40.4488 11.052 40.21 11.02H38.41V7.66999ZM42.24 18.34H38.41V15H42.24C43.4 15 44.15 15.54 44.15 16.67C44.15 17.8 43.4 18.34 42.24 18.34Z"
        fill="#002F54"
      />
      <path d="M56.3999 0.900024H51.4199V22.52H56.3999V0.900024Z" fill="#002F54" />
      <path d="M64.63 8.10999H59.65V22.53H64.63V8.10999Z" fill="#002F54" />
      <path
        d="M62.11 0.0600215C61.3246 0.0598644 60.5705 0.367685 60.0096 0.917383C59.4487 1.46708 59.1257 2.21482 59.11 3.00002C59.1546 3.78004 59.4959 4.51343 60.064 5.04987C60.632 5.58631 61.3837 5.88516 62.165 5.88516C62.9463 5.88516 63.698 5.58631 64.266 5.04987C64.834 4.51343 65.1753 3.78004 65.22 3.00002C65.2123 2.6017 65.1253 2.20891 64.9642 1.84456C64.803 1.4802 64.5709 1.1516 64.2814 0.877916C63.9919 0.604233 63.6508 0.390955 63.278 0.250528C62.9052 0.110101 62.5081 0.0453393 62.11 0.0600215Z"
        fill="#002F54"
      />
      <path
        d="M76.51 7.76006C75.0003 7.72303 73.5348 8.27127 72.42 9.29006V8.11006H67.88V22.5201H72.88V14.3601C72.8615 14.0798 72.9022 13.7988 72.9995 13.5354C73.0968 13.2719 73.2485 13.0319 73.4448 12.831C73.641 12.63 73.8773 12.4727 74.1384 12.3691C74.3995 12.2656 74.6794 12.2182 74.96 12.2301C75.2439 12.2124 75.5282 12.2554 75.7942 12.3563C76.0601 12.4572 76.3014 12.6137 76.502 12.8153C76.7027 13.0169 76.858 13.2589 76.9577 13.5253C77.0573 13.7917 77.099 14.0763 77.08 14.3601V22.5201H82.08V13.6401C82 10.0901 79.9 7.76006 76.51 7.76006Z"
        fill="#002F54"
      />
      <path
        d="M100.44 8.11002H94.6699L90.1499 13.93V0.900024H85.1699V22.52H90.1499V14.91L95.3099 22.52H100.79L95.4499 14.54L100.44 8.11002Z"
        fill="#002F54"
      />
      <path
        d="M104.87 0.0600215C104.085 0.0598644 103.331 0.367685 102.77 0.917383C102.209 1.46708 101.886 2.21482 101.87 3.00002C101.915 3.78004 102.256 4.51343 102.824 5.04987C103.392 5.58631 104.144 5.88516 104.925 5.88516C105.706 5.88516 106.458 5.58631 107.026 5.04987C107.594 4.51343 107.935 3.78004 107.98 3.00002C107.972 2.6017 107.885 2.20891 107.724 1.84456C107.563 1.4802 107.331 1.1516 107.041 0.877916C106.752 0.604233 106.411 0.390955 106.038 0.250528C105.665 0.110101 105.268 0.0453393 104.87 0.0600215Z"
        fill="#002F54"
      />
      <path d="M107.39 8.10999H102.41V22.53H107.39V8.10999Z" fill="#002F54" />
      <path
        d="M117.33 13.55L115.88 13C115.21 12.74 114.88 12.59 114.88 12.22C114.88 11.85 115.26 11.67 115.88 11.67C117.034 11.6843 118.143 12.1179 119 12.89L121.34 9.89001C120.628 9.18002 119.778 8.62442 118.842 8.25793C117.906 7.89144 116.904 7.72193 115.9 7.76001C112.57 7.76001 110.28 9.43001 110.28 12.32C110.28 14.71 111.84 15.89 114.48 16.96L116.1 17.62C116.65 17.85 116.94 18 116.94 18.34C116.94 18.83 116.36 18.98 115.67 18.98C114.154 18.9294 112.718 18.2868 111.67 17.19L109.35 20.13C110.104 21.0414 111.059 21.7658 112.14 22.2464C113.221 22.727 114.398 22.9507 115.58 22.9C119.03 22.9 121.58 21.14 121.58 18.11C121.56 15.66 119.91 14.59 117.33 13.55Z"
        fill="#002F54"
      />
      <path
        d="M132.19 18.43C130.36 18.43 129.7 17.88 129.7 16.52V12.26H133.58V8.11002H129.7V4.65002H124.7V8.11002H122.5V12.26H124.7V17C124.7 20.93 127.05 22.86 131.08 22.86C132.064 22.8581 133.044 22.7406 134 22.51V18.37C133.23 18.4 132.59 18.43 132.19 18.43Z"
        fill="#002F54"
      />
      <path
        d="M150.47 12.1601C151.001 11.7125 151.426 11.1512 151.711 10.5178C151.997 9.88427 152.137 9.19474 152.12 8.50006C152.12 5.50006 149.82 3.31006 146.28 3.31006H139.46V22.7801H147.81C151.65 22.7801 154.12 20.3901 154.12 17.1101C154.15 15.9962 153.807 14.9043 153.146 14.0075C152.485 13.1107 151.543 12.4605 150.47 12.1601ZM142.53 6.05006H146C148 6.05006 149 7.05006 149 8.65006C149 10.2501 148 11.3001 146 11.3001H142.55L142.53 6.05006ZM147.53 20.0501H142.53V14.0001H147.53C149.75 14.0001 150.96 15.2101 150.96 17.0001C150.96 18.7901 149.76 20.0001 147.54 20.0001L147.53 20.0501Z"
        fill="#1775FC"
      />
      <path
        d="M166.28 16.94C166.306 17.3701 166.243 17.801 166.094 18.2053C165.946 18.6097 165.714 18.9787 165.415 19.289C165.116 19.5992 164.756 19.844 164.358 20.0077C163.959 20.1714 163.531 20.2506 163.1 20.24C162.663 20.2586 162.226 20.1858 161.818 20.0263C161.411 19.8668 161.041 19.624 160.732 19.3135C160.424 19.003 160.183 18.6315 160.026 18.2229C159.869 17.8142 159.799 17.3773 159.82 16.94V8.29004H156.75V16.7C156.716 17.5505 156.854 18.399 157.157 19.1947C157.459 19.9904 157.918 20.7169 158.508 21.3305C159.098 21.9442 159.805 22.4325 160.588 22.766C161.372 23.0995 162.214 23.2714 163.065 23.2714C163.916 23.2714 164.758 23.0995 165.541 22.766C166.325 22.4325 167.032 21.9442 167.622 21.3305C168.212 20.7169 168.671 19.9904 168.973 19.1947C169.276 18.399 169.414 17.5505 169.38 16.7V8.29004H166.28V16.94Z"
        fill="#1775FC"
      />
      <path
        d="M179 14.31L177.61 13.75C176.28 13.22 175.69 12.84 175.69 12.04C175.69 11.24 176.52 10.65 177.69 10.65C178.326 10.6534 178.955 10.7864 179.537 11.0409C180.12 11.2953 180.645 11.6659 181.08 12.13L182.76 10.21C182.149 9.48481 181.381 8.90682 180.516 8.519C179.65 8.13119 178.708 7.94353 177.76 7.96998C174.9 7.96998 172.65 9.46998 172.65 12.16C172.65 14.34 174.1 15.4 176.43 16.38L177.9 17C179.08 17.47 179.9 17.85 179.9 18.8C179.9 19.75 178.84 20.42 177.57 20.42C176.784 20.3821 176.015 20.178 175.313 19.8212C174.612 19.4644 173.994 18.963 173.5 18.35L171.73 20.3C172.419 21.1886 173.305 21.9044 174.319 22.3905C175.333 22.8765 176.446 23.1195 177.57 23.1C180.46 23.1 182.94 21.6 182.94 18.68C183 16.55 181.66 15.4 179 14.31Z"
        fill="#1775FC"
      />
      <path
        d="M187.53 0.829976C187.255 0.824678 186.982 0.873904 186.726 0.974808C186.471 1.07571 186.237 1.22629 186.04 1.41785C185.843 1.6094 185.686 1.83813 185.578 2.09081C185.47 2.34349 185.413 2.61512 185.41 2.88998C185.416 3.16094 185.476 3.42794 185.587 3.67552C185.697 3.92311 185.855 4.14635 186.053 4.33235C186.25 4.51834 186.482 4.6634 186.735 4.75911C186.989 4.85483 187.259 4.89931 187.53 4.88998C188.077 4.90352 188.607 4.70125 189.005 4.32694C189.404 3.95263 189.639 3.4364 189.66 2.88998C189.649 2.33475 189.419 1.8063 189.02 1.42024C188.621 1.03417 188.085 0.821943 187.53 0.829976Z"
        fill="#1775FC"
      />
      <path d="M189.07 8.29004H185.97V22.77H189.07V8.29004Z" fill="#1775FC" />
      <path
        d="M200.18 7.99992C199.375 7.97568 198.573 8.12069 197.827 8.42558C197.081 8.73046 196.408 9.18844 195.85 9.76992V8.28992H193V22.7799H196.09V14.1299C196.069 13.6874 196.14 13.2453 196.298 12.8315C196.457 12.4177 196.699 12.0411 197.01 11.7255C197.321 11.4099 197.693 11.1621 198.105 10.9976C198.516 10.8331 198.957 10.7556 199.4 10.7699C199.835 10.76 200.267 10.8417 200.668 11.0097C201.07 11.1778 201.431 11.4284 201.729 11.7453C202.027 12.0622 202.255 12.4384 202.398 12.8492C202.542 13.26 202.597 13.6964 202.56 14.1299V22.7799H205.65V13.7199C205.61 10.3299 203.61 7.99992 200.18 7.99992Z"
        fill="#1775FC"
      />
      <path
        d="M215.91 7.99998C214.917 7.9945 213.934 8.18749 213.016 8.56761C212.099 8.94773 211.267 9.50731 210.57 10.2135C209.872 10.9196 209.322 11.7582 208.953 12.6797C208.584 13.6013 208.403 14.5874 208.42 15.58C208.411 16.5944 208.608 17.6 209 18.5359C209.391 19.4718 209.969 20.3184 210.697 21.0244C211.426 21.7304 212.29 22.2811 213.237 22.6431C214.185 23.005 215.196 23.1707 216.21 23.13C218.375 23.1356 220.456 22.2877 222 20.77L220.53 18.65C219.392 19.7363 217.883 20.3478 216.31 20.36C215.187 20.4396 214.076 20.0908 213.2 19.3838C212.325 18.6768 211.749 17.6642 211.59 16.55H222.38C222.531 15.914 222.611 15.2635 222.62 14.61C222.638 13.7284 222.476 12.8524 222.144 12.0356C221.812 11.2188 221.317 10.4783 220.689 9.85953C220.061 9.24074 219.313 8.75666 218.491 8.43692C217.67 8.11718 216.791 7.9685 215.91 7.99998ZM211.64 14.16C211.801 13.1726 212.308 12.2745 213.07 11.6261C213.832 10.9777 214.8 10.6211 215.8 10.62C216.28 10.5911 216.762 10.6615 217.214 10.827C217.665 10.9924 218.078 11.2492 218.427 11.5814C218.775 11.9137 219.051 12.3141 219.237 12.7578C219.424 13.2014 219.516 13.6788 219.51 14.16H211.64Z"
        fill="#1775FC"
      />
      <path
        d="M231.47 14.31L230.08 13.75C228.76 13.22 228.17 12.84 228.17 12.04C228.17 11.24 228.99 10.65 230.17 10.65C230.806 10.6534 231.435 10.7864 232.017 11.0409C232.6 11.2953 233.125 11.6659 233.56 12.13L235.25 10.21C234.639 9.48481 233.871 8.90682 233.006 8.519C232.14 8.13119 231.198 7.94353 230.25 7.96998C227.39 7.96998 225.15 9.46998 225.15 12.16C225.15 14.34 226.59 15.4 228.92 16.38L230.4 17C231.58 17.47 232.4 17.85 232.4 18.8C232.4 19.75 231.34 20.42 230.07 20.42C229.284 20.3821 228.515 20.178 227.813 19.8212C227.112 19.4644 226.494 18.963 226 18.35L224.23 20.3C224.919 21.188 225.806 21.9034 226.819 22.3894C227.833 22.8754 228.946 23.1187 230.07 23.1C232.96 23.1 235.44 21.6 235.44 18.68C235.42 16.55 234.09 15.4 231.47 14.31Z"
        fill="#1775FC"
      />
      <path
        d="M244.3 14.31L242.92 13.75C241.59 13.22 241 12.84 241 12.04C241 11.24 241.83 10.65 243 10.65C243.636 10.6546 244.264 10.7881 244.847 11.0425C245.429 11.2969 245.954 11.6668 246.39 12.13L248.07 10.21C247.448 9.48081 246.668 8.90283 245.79 8.51991C244.912 8.13699 243.957 7.95919 243 7.99998C240.13 7.99998 237.89 9.49998 237.89 12.19C237.89 14.37 239.34 15.43 241.67 16.41L243.14 17.03C244.32 17.5 245.14 17.88 245.14 18.83C245.14 19.78 244.08 20.45 242.81 20.45C242.024 20.4121 241.255 20.208 240.553 19.8512C239.852 19.4944 239.234 18.993 238.74 18.38L236.97 20.33C237.659 21.2186 238.545 21.9344 239.559 22.4205C240.573 22.9065 241.686 23.1495 242.81 23.13C245.7 23.13 248.18 21.63 248.18 18.71C248.26 16.55 246.93 15.4 244.3 14.31Z"
        fill="#1775FC"
      />
    </svg>
  </div>
</template>
<script>
export default {
  name: "BLogo",
  props: {
    type: { type: String, default: "full" }, // either "no-text" or "full" or "business"
    useDefaultSize: { type: Boolean, default: true },
    logoClasses: { type: String, default: "" }
  }
}
</script>

<style lang="scss" scoped>
.blinkist-logo {
  &--full,
  &--business {
    height: 22px;

    @include media(min-width, m) {
      height: 26px;
    }
  }
}
</style>
